import NestedForm from "stimulus-rails-nested-form";

export default class extends NestedForm {
  static targets = [...NestedForm.targets, "addButton"];
  static values = {
    ...NestedForm.values,
    minItems: {
      type: Number,
      default: 1,
    },
    maxItems: {
      type: Number,
      default: null,
    },
  };

  connect() {
    super.connect();
    this.updateAddButton();
    // Listen for turbo events to update buttons after form re-renders
    document.addEventListener("turbo:render", this.updateAllButtons.bind(this));
  }

  disconnect() {
    super.disconnect();
    document.removeEventListener(
      "turbo:render",
      this.updateAllButtons.bind(this),
    );
  }

  add(e) {
    super.add(e);
    // Update buttons after adding
    setTimeout(() => this.updateAllButtons(), 0);
  }

  remove(e) {
    super.remove(e);
    // Update buttons after removing
    setTimeout(() => this.updateAllButtons(), 0);
  }

  updateAllButtons() {
    this.updateAddButton();
  }


  updateAddButton() {
    if (!this.hasAddButtonTarget) return;

    const activeWrappers = this.element.querySelectorAll(
      this.wrapperSelectorValue + ':not([style*="display: none"])',
    );
    const currentCount = activeWrappers.length;
    // If no maxItems is set, don't modify the button
    if (this.maxItemsValue === null) return;

    const remainingSlots = this.maxItemsValue - currentCount;
    if (remainingSlots <= 0) {
      // Hide the add button completely
      this.addButtonTarget.style.display = "none";
    } else {
      // Show the button and update the text
      this.addButtonTarget.style.display = "";
      // Find the link inside the add button target and update its text
      const addLink = this.addButtonTarget.querySelector(
        'a[data-action*="with-counter-nested-form#add"]',
      );
      if (addLink) {
        const baseText =
          addLink.dataset.baseText || this.extractBaseText(addLink.textContent);
        addLink.dataset.baseText = baseText; // Store original text for future updates
        if (remainingSlots === 1) {
          addLink.textContent = `${baseText} (nog ${remainingSlots})`;
        } else {
          addLink.textContent = `${baseText} (nog ${remainingSlots})`;
        }
      }
    }
  }

  extractBaseText(fullText) {
    return fullText.replace(/\s*\(nog\s+\d+\)\s*$/, "").trim();
  }
}
